import { useMutation } from '@apollo/client';
import mutation from '../../mutations/saveSingleConfiguration';
import { ConfigurationInput, SaveSingleConfigurationResponse } from 'generated-types/graphql'

interface SaveConfigurationRequest {
  configuration: ConfigurationInput 
}

interface Response {
  saveSingleConfiguration: SaveSingleConfigurationResponse
}

export default function useSaveSingleConfiguration() {
  return useMutation<Response, SaveConfigurationRequest>(mutation);
}
